import { Link } from "react-router-dom";
import { SarvaMark } from "@/components/SarvaMark";
import { usePageMeta } from "@/lib/api";

export default function NotFoundPage() {
  usePageMeta("Page not found | SarvaRitam");
  return (
    <section className="bg-charcoal text-offwhite min-h-screen flex items-center justify-center relative grain" data-testid="not-found-page">
      <div className="wrap text-center relative py-32">
        <SarvaMark className="w-16 h-16 mx-auto mb-10" />
        <p className="font-display font-bold text-[100px] sm:text-[140px] leading-none text-gold/20" data-testid="not-found-code">404</p>
        <h1 className="h-display font-semibold text-2xl sm:text-3xl -mt-6">
          This page has <span className="serif-it text-gold">no materiality.</span>
        </h1>
        <p className="text-white/75 text-[15px] mt-5 max-w-md mx-auto leading-relaxed">
          The page you're looking for doesn't exist or has moved. Let's get you back to substance.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center mt-10">
          <Link to="/" className="btn-gold px-8 py-4 justify-center" data-testid="not-found-home-link">Back to home</Link>
          <Link to="/services" className="btn-ghost-light px-8 py-4 justify-center" data-testid="not-found-services-link">Explore our services</Link>
        </div>
      </div>
    </section>
  );
}
